<div class="radio-button-group">
  <label class="radio-button">
    <input type="radio"
           [value]="CART_DELIVERY_TYPES.DELIVERY"
           [name]="'delivery'"
           [(ngModel)]="type"
           (change)="onDataChanged.emit(CART_DELIVERY_TYPES.DELIVERY)"/>
    <span class="font-md fw-bold"
          [translate]="'orderProcess.giftDelivery.deliveryToDoor'">
       Delivery to door
     </span>&nbsp;<span class="font-md">+{{ price | currencyFormat: currency }}</span>
  </label>

  <label class="radio-button mt-2">
    <input type="radio"
           [value]="CART_DELIVERY_TYPES.PICKUP"
           [name]="'delivery'"
           [(ngModel)]="type"
           (change)="onDataChanged.emit(CART_DELIVERY_TYPES.PICKUP)"/>
    <div class="d-flex font-md">
      <div class="fw-bold me-1"
           [translate]="'orderProcess.giftDelivery.pickupInStore'">
        Pick up in store
      </div>

      (
      <div class="d-flex">
        <div class="me-1">
          {{'orderProcess.giftDelivery.pickupPoints' | translate: {
          count: pickupPointsCount
        } }}.
        </div>

        <div class="text-blue-2 pointer"
             [translate]="'orderProcess.giftDelivery.seeMap'"
             (click)="$event.preventDefault();$event.stopPropagation(); onShowOutletsMap.emit()">See map
        </div>
      </div>
      )
    </div>
  </label>
</div>
